import { Link } from 'react-router-dom';

function BlogPost() {
  return (
<section className="blog-details-area">
  <div className="container">
    <div className="row">
      <div className="col-lg-8">
        <div className="standard-blog-item mb-50">
          <div className="standard-blog-thumb">
            <img src="img/blog/blog_thumb01.jpg" alt="" />
          </div>
          <div className="standard-blog-content blog-details-content">
            <div className="blog-post-meta">
              <ul>
                <li className="tags"><i className="flaticon-bookmark-1" />
                  <a href="/#">Siberian Husky , </a>
                  <a href="/#">Race</a>
                </li>
                <li><i className="far fa-user" /><a href="/#">Admin</a></li>
                <li><i className="far fa-bell" /> 10 Mars 2021</li>
              </ul>
            </div>
            <h4 className="title">Animalia Plus – Tout ce dont votre animal a besoin en ligne</h4>
            <p>Le chien domestique est un descendant du loup. Il provient d’un loup ancien aujourd’hui éteint, et le loup gris moderne est le plus proche parent vivant du chien. Le chien a été la première espèce à être domestiquée par les chasseurs-cueilleurs.</p>
            <p>Les vaccins de base sont administrés à 6, 12 et 16 semaines. Il faut entre 3 et 5 jours pour que le chien commence à développer son immunité après la vaccination. Il est recommandé d’éviter tout contact avec le parvovirus tant que le chiot n’a pas complété sa série vaccinale.</p>
            <blockquote>
              “Le chiot commence à développer son immunité. Tant qu’il n’a pas reçu tous ses vaccins ou que le chien adulte n’est pas à jour, limitez son exposition au parvovirus.”
              <footer>Rosalina D. William</footer>
            </blockquote>
            <p>Les vaccins non obligatoires sont administrés selon le risque d’exposition du chien, notamment contre la Bordetella bronchiseptica, la Borrelia burgdorferi et la Leptospira.</p>
            <div className="blog-details-list">
              <ul>
                <li><a href="/#">La meilleure boutique pour animaux</a> – Notre application vous connecte à tous nos articles préférés pour chiens et chats.</li>
                <li><a href="/#">Vaccins essentiels pour les chiots</a> – Protégez votre chiot avec les soins recommandés par nos vétérinaires partenaires.</li>
              </ul>
            </div>
            <p>Le chien fut la première espèce domestiquée. Nos produits s'inspirent de cette relation millénaire entre l’homme et l’animal pour vous proposer le meilleur.</p>
            <div className="blog-details-img">
              <div className="row">
                <div className="col-md-6">
                  <img src="img/blog/blog_details_img01.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img src="img/blog/blog_details_img02.jpg" alt="" />
                </div>
              </div>
            </div>
            <p>Les vaccins non essentiels sont administrés selon les besoins. Protégez votre animal avec nos soins et produits sélectionnés chez Animalia Plus.</p>
            <div className="blog-line" data-background="img/blog/blog_item_line.png" />
            <div className="blog-details-bottom">
              <div className="blog-details-tags">
                <ul>
                  <li className="title"><i className="fas fa-tags" /> Tags :</li>
                  <li><a href="/#">Bien-être</a></li>
                  <li><a href="/#">Produits</a></li>
                  <li><a href="/#">Conseils</a></li>
                  <li><a href="/#">Animalerie</a></li>
                </ul>
              </div>
              <div className="blog-details-social">
                <ul>
                  <li><a href="/#"><i className="fab fa-facebook-f" /></a></li>
                  <li><a href="/#"><i className="fab fa-twitter" /></a></li>
                  <li><a href="/#"><i className="fab fa-linkedin-in" /></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="avatar-post mt-50 mb-50">
          <div className="post-avatar-img">
            <img src="img/blog/post_avatar_img.png" alt="img" />
          </div>
          <div className="post-avatar-content">
            <h5>Thomas Herlihy</h5>
            <p>Chez Animalia Plus, nous adaptons nos produits en fonction du style de vie et des besoins de vos compagnons.</p>
            <div className="blog-details-social">
              <ul>
                <li><a href="/#"><i className="fab fa-facebook-f" /></a></li>
                <li><a href="/#"><i className="fab fa-twitter" /></a></li>
                <li><a href="/#"><i className="fab fa-linkedin-in" /></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="blog-next-prev">
          <ul>
            <li className="blog-prev">
              <a href="/#"><img src="img/icon/left_arrow.png" alt="img" />Article Précédent</a>
            </li>
            <li className="blog-next">
              <a href="/#">Article Suivant<img src="img/icon/right_arrow.png" alt="img" /></a>
            </li>
          </ul>
        </div>

        <div className="comment-reply-box">
          <h5 className="title">Laisser un commentaire</h5>
          <form className="comment-reply-form">
            <div className="row">
              <div className="col-md-6">
                <div className="form-grp">
                  <input type="text" placeholder="Nom *" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-grp">
                  <input type="email" placeholder="Votre Email *" />
                </div>
              </div>
            </div>
            <div className="form-grp">
              <textarea name="message" placeholder="Votre commentaire..." defaultValue={""} />
            </div>
            <div className="form-grp checkbox-grp">
              <input type="checkbox" id="checkbox" />
              <label htmlFor="checkbox">Ne pas afficher mon adresse email</label>
            </div>
            <button type="submit" className="btn">Envoyer</button>
          </form>
        </div>
      </div>

      <div className="col-lg-4">
        <aside className="blog-sidebar">
          <div className="widget">
            <h4 className="sidebar-title">Recherche</h4>
            <div className="sidebar-search">
              <form>
                <input type="text" placeholder="Rechercher..." />
                <button type="submit"><i className="fa fa-search" /></button>
              </form>
            </div>
          </div>

          <div className="widget">
            <h4 className="sidebar-title">Catégories</h4>
            <div className="sidebar-cat-list">
              <ul>
                <li><a href="/#">Siberian Husky <i className="fas fa-angle-double-right" /></a></li>
                <li><a href="/#">Berger Allemand <i className="fas fa-angle-double-right" /></a></li>
                <li><a href="/#">Bouledogue Français <i className="fas fa-angle-double-right" /></a></li>
                <li><a href="/#">Golden Retriever <i className="fas fa-angle-double-right" /></a></li>
              </ul>
            </div>
          </div>

          <div className="widget">
            <h4 className="sidebar-title">Articles récents</h4>
            <div className="rc-post-list">
              <ul>
                <li>
                  <div className="rc-post-thumb">
                    <Link to="/blog-details"><img src="img/blog/rc_post_thumb01.jpg" alt="" /></Link>
                  </div>
                  <div className="rc-post-content">
                    <h5 className="title"><Link to="/blog-details">Animalia Plus : Tous les essentiels pour votre animal</Link></h5>
                    <div className="rc-post-meta">
                      <ul>
                        <li><i className="far fa-calendar-alt" /> 15 Avril 2021</li>
                        <li>Par <a href="/#">Admin</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="rc-post-thumb">
                    <Link to="/blog-details"><img src="img/blog/rc_post_thumb02.jpg" alt="" /></Link>
                  </div>
                  <div className="rc-post-content">
                    <h5 className="title"><Link to="/blog-details">Nos animaux méritent une alimentation spéciale</Link></h5>
                    <div className="rc-post-meta">
                      <ul>
                        <li><i className="far fa-calendar-alt" /> 15 Octobre 2021</li>
                        <li>Par <a href="/#">Admin</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="widget sidebar-newsletter">
            <div className="sn-icon">
              <img src="img/icon/sn_icon.png" alt="" />
            </div>
            <div className="sn-title">
              <h4 className="title">Inscription à la newsletter</h4>
              <p>Recevez nos dernières actualités</p>
            </div>
            <form className="sn-form">
              <input type="text" placeholder="Entrez votre email" />
              <button className="btn">S’abonner</button>
            </form>
          </div>
        </aside>
      </div>
    </div>
  </div>
</section>


  )
}

export default BlogPost;
